/**
 *   The aim of this function is to provide TS transpiler with place, where it can:
 *      a) give hints of possible CSS properties in input object
 *      b) properly infer output object keys
 */
export function defineStyles(stylesObject) {
    return stylesObject;
}
/**
 *  simple function for inline style definition
 */
export function defineStyle(styleObject) {
    return styleObject;
}
//# sourceMappingURL=defineStyles.js.map